import { useEffect, useState } from "react";
import { useDragDropManager } from "react-dnd";

interface IUseWebsiteBuilderDndManager {
  isDragging: boolean;
  item: unknown;
}

export function useWebsiteBuilderDndManager(): IUseWebsiteBuilderDndManager {
  const dragDropManager = useDragDropManager();
  const monitor = dragDropManager.getMonitor();

  const [dndManager, setDndManager] = useState<IUseWebsiteBuilderDndManager>({
    isDragging: monitor.isDragging(),
    item: monitor.getItem(),
  });

  useEffect(() => {
    const unsubscribe = monitor.subscribeToStateChange(() => {
      setDndManager({
        isDragging: monitor.isDragging(),
        item: monitor.getItem(),
      });
    });

    return unsubscribe;
  }, [monitor]);

  return dndManager;
}
